<template>
	<div>
		<div class="b1 bc7 p4 bg5 r2">
			<template v-if="component_">
				<component
					v-if="plan_"
					:is="component_"
					@pricing:updated="$emit('pricing:updated')"
					v-bind="{
						productId,
						policyId,
						rawValues,
						clauses,
						isEditable,
						endorsementId,
						contractInsured
					}"
				/>
				<!-- Warning if premium is overriden -->
				<div
					class="xs-12 bgWarning p0 r2 mt2"
					v-if="isPremiumOverriden && isEditable"
				>
					<div class="flex xs-between xs-middle p4">
						<div class="lh125 fs3">
							Premium has been overriden, so updating the pricing will not
							automatically update the premium with this total amount.
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
// import SelectProduct from "../SelectProduct.vue"
import PricingJewellersBlockPrimaryLayer from "./JB/PricingJewellersBlockPrimaryLayer"
import PricingJewellersBlockExcessLayer from "./JB/PricingJewellersBlockExcessLayer"
import PricingJewellersBlockOpenMarket from "./JB/PricingJewellersBlockOpenMarket"
import PricingEmployeesCompensationPrimaryLayer from "./EC/PricingEmployeesCompensationPrimaryLayer"
import PricingPersonalJewelleryPrimaryLayer from "./PJ/PricingPersonalJewelleryPrimaryLayer"
import PricingCommercialBlockPrimaryLayer from "./CB/PricingCommercialBlockPrimaryLayer"
import PricingJewellersExhibitionPrimaryLayer from "./EX/PricingJewellersExhibitionPrimaryLayer"
import PricingJewellersExhibitionExcessLayer from "./EX/PricingJewellersExhibitionExcessLayer"
import PricingPublicLiabilityPrimaryLayer from "./MS/PricingPublicLiabilityPrimaryLayer"
import PricingJewellersTourPrimaryLayer from "./TO/PricingJewellersTourPrimaryLayer"
import PricingSendingInsurancePrimaryLayer from "./SH/PricingSendingInsurancePrimaryLayer"

export default {
	components: {
		PricingJewellersBlockPrimaryLayer,
		PricingJewellersBlockExcessLayer,
		PricingJewellersBlockOpenMarket,
		PricingEmployeesCompensationPrimaryLayer,
		PricingPersonalJewelleryPrimaryLayer,
		PricingCommercialBlockPrimaryLayer,
		PricingJewellersExhibitionPrimaryLayer,
		PricingJewellersExhibitionExcessLayer,
		PricingPublicLiabilityPrimaryLayer,
		PricingJewellersTourPrimaryLayer,
		PricingSendingInsurancePrimaryLayer
	},

	props: {
		label: {
			type: String,
			default: "Pricing Calculation"
		},
		productId: {
			validator(val) {
				return val === null || typeof val === "object"
			}
		},
		policyId: String,
		rawValues: Array,
		clauses: Array,
		isEditable: Boolean,
		contractInsured: Array,
		endorsementId: {
			type: String,
			required: false,
			default: undefined
		},
		isPremiumOverriden: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			// Dictionary of pricing components that can be used
			dictionary: {
				jewellers_block_primary_layer_hkd: "PricingJewellersBlockPrimaryLayer",
				jewellers_block_primary_layer_usd: "PricingJewellersBlockPrimaryLayer",
				jewellers_block_excess_layer_hkd: "PricingJewellersBlockExcessLayer",
				jewellers_block_excess_layer_usd: "PricingJewellersBlockExcessLayer",
				jewellers_block_open_market_hkd: "PricingJewellersBlockOpenMarket",
				jewellers_block_open_market_usd: "PricingJewellersBlockOpenMarket",
				employees_compensation: "PricingEmployeesCompensationPrimaryLayer",
				personal_jewellery: "PricingPersonalJewelleryPrimaryLayer",
				commercial_block: "PricingCommercialBlockPrimaryLayer",
				jewellers_exhibition_primary_layer:
					"PricingJewellersExhibitionPrimaryLayer",
				jewellers_exhibition_excess_layer:
					"PricingJewellersExhibitionExcessLayer",
				public_liability_event_and_exhibition:
					"PricingPublicLiabilityPrimaryLayer",
				public_liability_advertising_signs_and_decoration:
					"PricingPublicLiabilityPrimaryLayer",
				jewellers_tour_primary_layer: "PricingJewellersTourPrimaryLayer",
				sending: "PricingSendingInsurancePrimaryLayer"
			}
		}
	},

	computed: {
		plan_() {
			return this.productId?.plan
		},

		component_() {
			return this.dictionary[this.plan_] ? this.dictionary[this.plan_] : null
		}
	}
}
</script>
